import PropTypes from 'prop-types';
import React from 'react';
import styles from './fluid-avatar-image.scss';
import classNames from 'classnames';

const getStyle = image => {
  return image ? { backgroundImage: `url(${image})` } : {};
};

const FluidAvatarImage = ({ image }) =>
  <div className={classNames(styles.container, 'fluid-avatar-image')} style={getStyle(image)}/>;

FluidAvatarImage.propTypes = {
  image: PropTypes.string,
};

export default FluidAvatarImage;



// WEBPACK FOOTER //
// ./app/components/fluid-avatar-image/fluid-avatar-image.js